module.exports = __webpack_public_path__ + "img/a4.7f1cb120.png";